import { d } from "./index795.mjs";
import { f as y } from "./index743.mjs";
import { f as j } from "./index773.mjs";
import { f as h } from "./index758.mjs";
import { o as O } from "./index757.mjs";
import "./index796.mjs";
import "./index797.mjs";
import { t as P } from "./index756.mjs";
import { i as x } from "./index798.mjs";
import { __exports as w } from "./index799.mjs";
import { __exports as E } from "./index800.mjs";
var b = d, I = y, T = j, _ = h, m = O, $ = w, A = E, C = P, K = x, r = Object.assign, l = Object.defineProperty, M = I([].concat), J = !r || _(function() {
  if (b && r({ b: 1 }, r(l({}, "a", {
    enumerable: !0,
    get: function() {
      l(this, "b", {
        value: 3,
        enumerable: !1
      });
    }
  }), { b: 2 })).b !== 1)
    return !0;
  var s = {}, a = {}, i = Symbol("assign detection"), e = "abcdefghijklmnopqrst";
  return s[i] = 7, e.split("").forEach(function(o) {
    a[o] = o;
  }), r({}, s)[i] !== 7 || m(r({}, a)).join("") !== e;
}) ? function(a, i) {
  for (var e = C(a), o = arguments.length, f = 1, c = $.f, u = A.f; o > f; )
    for (var t = K(arguments[f++]), p = c ? M(m(t), c(t)) : m(t), g = p.length, v = 0, n; g > v; )
      n = p[v++], (!b || T(u, t, n)) && (e[n] = t[n]);
  return e;
} : r;
export {
  J as o
};
